import { Injectable } from '@angular/core';
import { ContainerClient, BlobServiceClient } from '@azure/storage-blob';
import { Guid } from 'typescript-guid';
import { ContainerNames } from '../models/container-names.model';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth.service';

// Copy of the NgV3 BlobStorageService upload, so shared-lib components can upload to caimsmsstorage.
@Injectable({
  providedIn: 'root'
})
export class BlobStorageService {
    private accountName: string = "caimsmsstorage";
    private containerName: string = '';
    private sasTokens: { [containerName: string]: { token: string, expiresOn: number } } = {};

    constructor(private authService: AuthService) {}

    public setContainer(containerName: ContainerNames) {
        this.containerName = containerName;
    }

    public uploadFile(
        content: Blob,
        name: string,
        successHandler: (url: string) => void,
        errorHandler: (error: any) => void
    ) {
        this.containerClientWithSas()
            .then((client) => {
                const blockBlobClient = client.getBlockBlobClient(`${name}_${Guid.create()}`);
                return blockBlobClient.uploadData(content, { blobHTTPHeaders: { blobContentType: content.type } })
                    .then(() => successHandler(blockBlobClient.url.split('?')[0]));
            })
            .catch((error: any) => errorHandler(error));
    }

    private async containerClientWithSas(): Promise<ContainerClient> {
        const containerName = this.containerName;
        const cached = this.sasTokens[containerName];
        if (!cached || cached.expiresOn < Date.now()) {
            const responseData = (await firstValueFrom(this.authService.getSas(containerName))).body;
            if (responseData?.status !== 200 && responseData?.status !== 'OK') {
                throw new Error(responseData?.message);
            }
            this.sasTokens[containerName] = { token: responseData.data, expiresOn: Date.now() + 25 * 60 * 1000 };
        }
        return new BlobServiceClient(`https://${this.accountName}.blob.core.windows.net${this.sasTokens[containerName].token}`).getContainerClient(containerName);
    }
}
